import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { usePageTitle } from '../hooks/usePageTitle';
import { LayoutContainer, MessageBlock } from '../components/ui';
import api from '../services/api';
import { CALLBACK_EXCHANGE_ERROR, getCallbackExchangeErrorType } from '../utils/callbackExchangeError';
import '../styles/infrastructureScreens.css';

/**
 * Página de callback para retorno desde Valida/Signatura.
 * Recibe uid firmado en la query, lo intercambia por customer_token en el backend
 * y redirige al flujo de onboarding.
 */
const MobileCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [errorType, setErrorType] = useState('invalid_token');
  const [retryPath, setRetryPath] = useState(null);

  usePageTitle('Portal Autogestión');

  useEffect(() => {
    const uid = searchParams.get('uid');
    const fromStep = searchParams.get('from_step') || 'identity_validation';

    if (!uid) {
      setErrorType('invalid_token');
      setStatus('error');
      return;
    }

    api
      .post('/self-service/exchange-callback-uid', { uid })
      .then((res) => {
        if (res.data?.success && res.data?.customer_token) {
          setStatus('success');
          navigate(`/m/onboarding/${res.data.customer_token}/flow?from_step=${fromStep}`, {
            replace: true
          });
        } else {
          setErrorType('invalid_token');
          setStatus('error');
        }
      })
      .catch((err) => {
        const type = getCallbackExchangeErrorType(err);
        setErrorType(type);
        if (type === CALLBACK_EXCHANGE_ERROR.NETWORK_ERROR) {
          setRetryPath(`${window.location.pathname}${window.location.search}`);
        }
        setStatus('error');
      });
  }, [searchParams, navigate]);

  if (status === 'loading') {
    return (
      <div className="rg-infra-screen rg-mobile-callback">
        <LayoutContainer size="md" className="rg-mobile-callback__container">
          <div className="rg-mobile-callback__loading" role="status" aria-live="polite">
            <FontAwesomeIcon icon={faSpinner} className="fa-spin rg-mobile-callback__spinner" />
            <p className="rg-mobile-callback__loading-text">Verificando identidad...</p>
          </div>
        </LayoutContainer>
      </div>
    );
  }

  if (status === 'error') {
    navigate(`/m/error/${errorType}`, {
      replace: true,
      state: retryPath ? { retryPath } : undefined
    });
    return null;
  }

  return null;
};

export default MobileCallbackPage;
